<template>
  <div class="swiper-item" :style="translate" :class="transition">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    translate: {
      type: String,
      default: null
    },
    transition: {
      type: String,
      default: null
    }
  }
}
</script>
